<template>
  <v-dialog 
    v-model="dialog"
    fullscreen
    :transition="false"
  >
    <div class="story">
      <div class="process-bar">
        <v-progress-linear 
          v-for="(product, i) in products" 
          :key="i"
          :value="i < active ? 100 : i > active ? 0 : product.progress" 
          color="white" 
          height="2.5"
        ></v-progress-linear>
      </div>
      <div v-for="(product, i) in products" :key="i">
        <div v-if="active == i">
          <div class="video-block">
            <Watermark v-if="isLogin" :mark="user.id | member"></Watermark>
            <video-player
              v-if="product.type == 'video'"
              v-once
              :ref="`video${i}`"
              :playsinline="true"
              @canplay="onPlayerCanplay($event)"
              @loadeddata="onPlayerLoadeddata($event, product)"
              :options="$func.videoOption({
                src: $HOST_URL + product.data.uuid_path,
                autoplay: $videojs.browser.IS_SAFARI ? true : false,
                muted: true,
                loop: products.length > 1 ? false : true,
                controls: false,
                poster: $HOST_URL + product.data.preview_path,
                fluid: false,
                aspectRatio: null
              })"></video-player>
            <v-img
              v-else-if="product.type == 'image'"
              v-auth-src="$HOST_URL + product.data.uuid_path"
              contain
            ></v-img>
          </div>
          <div class="content">
            <div class="user">
              <router-link :to="`/seller/${seller.id}`">
                <v-avatar size="40">
                  <v-img :src="$HOST_URL + seller.usericon"/>
                </v-avatar>
                <div class="information">
                  <div class="text-ellipsis">{{ seller.nickname }}</div>
                  <span v-if="$func.dayDiff(product.created_at) === 0">{{ product.created_at | time }}</span>
                  <span v-else-if="$func.dayDiff(product.created_at) === 1">
                    昨天 {{ product.created_at | time }}
                  </span>
                  <span v-else-if="$func.isThisYear(product.created_at)">{{ product.created_at | dateWithoutYear }}</span>
                  <span v-else>{{ product.created_at | dateWithYear }}</span>
                </div>
              </router-link>
              <v-spacer></v-spacer>
              <v-btn icon @click="toggleMute" v-if="product.type == 'video'">
                <v-icon color="white">{{ muted ? 'volume_off' : 'volume_up' }}</v-icon>
              </v-btn>
              <v-btn icon @click="dialog = false">
                <v-icon color="white">close</v-icon>
              </v-btn>
            </div>
            <div class="description">
              <h3 class="mb-2">{{ product.title }}</h3>
              <template v-if="product.remark">
                <p v-for="content in product.remark.split('\n')" :key="content">
                  {{ content }}
                </p>
              </template>
            </div>
          </div>
          <!-- 只有在需要付費且未解鎖時才顯示解鎖資訊 -->
          <div class="unlock" v-if="product.price > 0 && !purchaseID.includes(product.id)">
            <div class="review">
              <div>
                <v-icon>fa-thumbs-up</v-icon>
                <span>{{ mul(product.praise_rate, 100) }}%</span>
              </div>
              <div>
                <v-icon>fa-unlock</v-icon>
                <span>{{ product.unlocks }}</span>
              </div>
              <div v-if="product.product_type == 'story'">
                <v-icon>fa-clock</v-icon>
                <span>{{ $moment.duration($moment(product.created_at).add(3, 'M') - $moment()).format('d[天] HH:mm:ss') }}</span>
              </div>
            </div>
            <v-btn
              outlined
              rounded
              color="pink"
              class="buy"
              @click="
                ready_to_buy = product;
                $root.$emit('confirmDialog', buy, `確定支付 <span class='d-inline-flex pink--text'><div class='peach'></div>${product.price}</span> 解鎖該${product.product_type == 'story' ? '限時動態' : '寫真'}？${product.product_type == 'story' ? `<div class='red--text caption'>注意！動態在發布後3個月將會完全刪除</div>` : ''}`)"
            >
              <div class="peach"></div>
              <div class="font-weight-bold ml-1 mr-2">{{ product.price }}</div>| 解鎖
            </v-btn>
            <v-btn 
              v-if="purchaseID.includes(product.id)" 
              icon 
              dark 
              color="pink"
              @click="like(product.id)"
            >
              <v-icon v-if="likeID.includes(product.id)">fa-thumbs-up</v-icon>
              <v-icon v-else>far fa-thumbs-up</v-icon>
            </v-btn>
          </div>
        </div>
        <v-row no-gutters class="action">
          <v-col cols="3" @click="action('left')"></v-col>
          <v-col cols="9" @click="action('right')"></v-col>
        </v-row>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Watermark from '@/components/Watermark'
export default {
  // props: ['seller', 'product', 'product_type'],
  components: { Watermark },
  data() {
    return {
      dialog: false,
      active: null,
      seller: {},
      product: {},
      product_type: '',
      products: [],
      interval: null,
      ready_to_buy: null,
      image_time: 5,
      update_interval: 100,
      muted: true
    }
  },
  created() {
    this.$root.$on('story', this.open)
  },
  mounted() {
    // 處理直接訪問 URL 的情況
    if (this.$route.params.id && !this.dialog) {
      this.loadFromUrl(this.$route.params.id)
    }
  },
  beforeDestroy() {
    this.$root.$off('story', this.open)
  },
  // beforeRouteLeave(to, from, next) {
  //   clearInterval(this.interval)
  //   next()
  // },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['isLogin', 'purchaseID', 'likeID'])
  },
  watch: {
    dialog(newValue) {
      if(!newValue) {
        clearInterval(this.interval)
        Object.assign(this.$data, this.$options.data.apply(this))
      }
    },
    active(newValue, oldValue) {
      if(newValue != null && oldValue != null) {
        if(this.products[newValue].product_type == 'story') {
          this.$store.dispatch('global/viewCount', this.products[newValue].id)
        }
        this.$delete(this.products[oldValue], 'player')
      }
    }
  },
  methods: {
    loadFromUrl(productId) {
      // 從 API 取得商品資料
      this.axios(`/product/${productId}`).then(response => {
        const product = response.data
        // 取得賣家資料
        this.axios(`/seller/${product.seller_id}`).then(sellerResponse => {
          this.open(sellerResponse.data, product, product.product_type)
        }).catch(() => {
          this.$router.push('/')
        })
      }).catch(() => {
        this.$root.$emit('errorDialog', ['該商品不存在', {type: 'btn', text: '返回首頁', action: () => this.$router.push('/')}], true)
      })
    },
    open(seller, product, product_type) {
      [this.seller, this.product, this.product_type] = [seller, product, product_type]
      this.dialog = true
      console.log('open')
      if(this.seller) {
        console.log(seller, product, product_type)
        this.getProducts().then(() => {
          document.title = `${this.products.find(product => product.id == this.product.id).title} - ${this.$TITLE}`
          this.$store.dispatch('global/viewCount', this.product.id)
          this.products = this.products.map(product => {
            console.log('settt')
            this.$set(product, 'progress', 0)
            return product
          })
          this.interval = setInterval(this.checkPlayerStatus, this.update_interval)
        })
      }
      else {
        // if(this.$func.inSellerPortal()) {
        //   this.$router.push('/portal')
        // }
        // else {
        //   this.$router.push('/')
        // }
        this.dialog = false
      }
    },
    getProducts() {
      console.log(this.product_type)
      if(this.product_type == 'story') {
        return this.axios(`/seller/${this.seller.id}/products?product_type=story&page=1&size=9999`)
          .then(response => {
            this.products = response.data.data.filter(product => product.shelf || this.purchaseID.includes(product.id)).map(product => {
              product.type = product.image_info[0] ? 'image' : 'video'
              product = {...product, data: product.type == 'video' ? product.video_info[0] : product.image_info[0]}
              return product
            })
            this.active = this.products.findIndex(product => product.id == this.product.id)
            if(this.active == -1) {
              throw new Error('Story does not exist')
            }
          })
          .catch(e => {
            this.$root.$emit('errorDialog', ['該動態不存在或已過期', {type: 'btn', text: '返回上一頁', action: () => this.dialog = false}], true)
          })
      }
      else if(this.product_type == 'photo') {
        return this.axios(`/product/${this.product.id}`)
          .then(response => {
            this.active = 0
            let videos = response.data.video_info.map(product => {
              product.type = 'video'
              return product
            })
            let images = response.data.image_info.map(product => {
              product.type = 'image'
              return product
            })
            this.products = [...videos, ...images].map(product => {
              return {data: product, type: product.type, ...response.data}
            })
          })
          .catch(() => {
            this.$root.$emit('errorDialog', ['該寫真不存在或已過期', {type: 'btn', text: '返回上一頁', action: () => this.dialog = false}], true)
          })
      }
      else if(this.product_type == 'chat') {
        console.log('chat')
        this.active = 0
        let videos = this.product.video_info.map(product => {
          product.type = 'video'
          return product
        })
        let images = this.product.image_info.map(product => {
          product.type = 'image'
          return product
        })
        this.products = [...videos, ...images].map(product => {
          return {data: product, type: product.type, ...this.product}
        })
        console.log(this.products)
        return Promise.resolve()
      }
    },
    onPlayerCanplay(player) {
      player.play()
      player.muted(this.muted)
    },
    onPlayerLoadeddata(player, product) {
      this.$set(product, 'player', player)
    },
    toggleMute() {
      this.muted = !this.muted
      const product = this.products[this.active]
      if (product && product.player) {
        product.player.muted(this.muted)
      }
    },
    checkPlayerStatus() {
      let product = this.products[this.active]
      if(product.type == 'image') {
        product.progress += this.update_interval / (this.image_time * 10)
      }
      else if(product.type == 'video') {
        if(!product.player) {
          return
        }
        product.progress = product.player.currentTime() / product.player.duration() * 100    
      }
      if(product.progress >= 100) {
        product.progress = 0
        this.active = (this.active + 1) % this.products.length
        this.$forceUpdate()
      }
    },
    action(direction) {
      if(this.products.length == 1) {
        return
      }
      this.$set(this.products[this.active], 'progress', 0)
      if(direction == 'left') {
        this.active = (this.active - 1 + this.products.length) % this.products.length
      }
      else {
        this.active = (this.active + 1) % this.products.length
      }
      this.$forceUpdate()
    },
    buy() {
      this.axios.post('/member/online/buy', {
        product_id: this.ready_to_buy.id
      }).then(response => {
        this.$root.$emit('alert', 'success', '解鎖成功')
        this.$store.dispatch('user/getPurchaseID')
        this.$store.dispatch('user/getUserInformation')
        if(this.product_type == 'story') {
          this.active = this.products.indexOf(this.ready_to_buy)
          if(this.ready_to_buy.type == 'video') {
            this.$func.stopPlayVideo(this.$refs, this.active)
            this.ready_to_buy.player.src(this.$func.videoSrcWithToken(this.$HOST_URL + this.ready_to_buy.data.uuid_path))
          }
          else if(this.ready_to_buy.type == 'image') {
            this.ready_to_buy.data.uuid_path += '?t=1'
          }
        }
        else if (['photo', 'chat'].includes(this.product_type)) {
          this.products.forEach(product => {
            if(product.type == 'video' && 'player' in product) {
              product.player.src(this.$func.videoSrcWithToken(this.$HOST_URL + product.data.uuid_path))
            }
            else if(product.type == 'image') {
              product.data.uuid_path += '?t=1'
            }
          })
          this.active = 0
        }
      }).catch(e => {
        this.$root.$emit('alert', 'error', '解鎖失敗')
      })
    },
    like(id) {
      this.axios.post('/member/praise', {
        product_id: id
      }).then(response => {
        this.$store.dispatch('user/getLikeID')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.story {
  background: $grey-2;
  position: relative;
  height: 100%;
  .action {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
  .v-btn {
    z-index: 10;
  }
  .video-block {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: black;
    .v-responsive {
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
    }
    .video-player, .video-js {
      width: 100% !important;
      height: 100% !important;
      video {
        object-fit: contain !important;
        width: 100% !important;
        height: 100% !important;
      }
    }
    .v-responsive__content {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .v-image {
      max-width: 100%;
      max-height: 100%;
      .v-image__image {
        background-size: contain !important;
      }
    }
  }
  .process-bar {
    display: flex;
    padding: 16px 0 8px 0;
    position: relative;
    z-index: 10;
    .v-progress-linear {
      margin: 0 2px;
    }
  }
  .content {
    position: relative;
    padding: 16px;
    @include mobile {
      padding: 16px 6px;
    }
    .user {
      position: relative;
      display: flex;
      align-items: center;
      font-size: 14px;
      z-index: 1;
      a {
        display: flex;
      }
      .information {
        overflow: auto;
        margin-left: 12px;
        max-width: 300px;
        @include mobile {
          margin-left: 6px;
        }
      }
      span {
        color: $grey-1;
        font-size: 12px;
      }
    }
    .description {
      margin-top: 16px;
      font-size: 14px;
      p {
        overflow-wrap: break-word;
      }
    }
  }
  .unlock {
    position: absolute;
    display: flex;
    align-items: center;
    width: 100%;
    bottom: 16px;
    padding: 0 16px;
    .review {
      @include mobile {
        max-width: 105px;

      }
    }
    .buy {
      letter-spacing: 4px;
      font-size: 14px;
      flex-grow: 1;
      margin: 0 12px;
    }
  }
}
</style>